import {
  Box,
  Text,
  UnorderedList,
  ListItem,
  OrderedList,
  List,
  Heading,
} from "@chakra-ui/react";

const Terms01 = () => {
  return (
    <Box maxW="4xl" mx="auto" p="5" color="gray.700">
      <List>
        <ListItem>
          <Heading as="h3" size="md" mt="5" mb="2">
            제 1장 총칙
          </Heading>
          <UnorderedList>
            <ListItem>
              <Heading as="h4" size="sm" mt="3">
                제1조 (목적)
              </Heading>
              <Text>
                본 약관은 선한영향력가게 홈페이지 (이하 '당 홈페이지')가
                제공하는 모든 서비스(이하 '서비스')의 이용조건 및 절차,
                이용자/회원과 당 홈페이지의 권리, 의무, 책임사항과 기타 필요한
                사항을 규정함을 목적으로 합니다.
              </Text>
            </ListItem>
          </UnorderedList>
        </ListItem>
        <ListItem>
          <Heading as="h4" size="sm" mt="3">
            제2조 (약관의 효력과 변경)
          </Heading>
          <OrderedList listStyleType="decimal" pl="4">
            <ListItem mb="2">
              당 홈페이지는 이용자/회원이 본 약관 내용에 동의하는 것을 조건으로
              이용자/회원에 한하여 서비스를 제공할 것이며, 이용자/회원이 본
              약관의 내용에 동의하는 경우, 당 홈페이지의 서비스 제공 행위 및
              이용자/회원의 서비스 사용 행위에는 본 약관이 우선적으로
              적용됩니다.
            </ListItem>
            <ListItem mb="2">
              당 홈페이지는 합리적 이유가 있는 경우 약관을 변경할 수 있으며,
              변경된 약관은 서비스 화면에 게재하거나 기타 방법으로 이용자에게
              공지함으로써 효력을 발생합니다.
            </ListItem>
            <ListItem>
              회원은 변경된 약관에 동의하지 않을 경우, 서비스 이용을 중단하고
              탈퇴할 수 있습니다. 약관이 변경된 이후에도 계속적으로 서비스를
              이용하는 경우에는 회원이 약관의 변경 사항에 동의한 것으로 봅니다.
            </ListItem>
          </OrderedList>
        </ListItem>
        <ListItem>
          <Heading as="h4" size="sm" mt="3">
            제3조 (약관 외 준칙)
          </Heading>
          <OrderedList listStyleType="decimal" pl="4">
            <ListItem mb="2">
              본 약관에 명시되지 않은 사항이 국내 관계법령에 규정되어 있을
              경우에는 그 규정에 따릅니다.
            </ListItem>
            <ListItem>
              본 약관 이외에 개별 서비스에 대한 세부적인 사항을 정할 수 있으며,
              그 내용은 개별 이용 동의 절차에 따릅니다.
            </ListItem>
          </OrderedList>
        </ListItem>
        <ListItem>
          <Heading as="h4" size="sm" mt="3">
            제4조 (용어의 정의)
          </Heading>
          <Text mb="2">
            본 약관에서 사용하는 용어의 정의는 다음과 같습니다.
          </Text>
          <OrderedList listStyleType="decimal" pl="4">
            <ListItem mb="2">
              이용자 : 당 홈페이지에 접속하여 본 약관에 따라 선한영향력가게(이하
              ‘협회’)가 제공하는 콘텐츠를 이용하는 회원 및 방문자.
            </ListItem>
            <ListItem mb="2">
              가입 : 본 약관에 따라 당 홈페이지의 서비스를 받기 위해 가입을 하는
              행위.
            </ListItem>
            <ListItem mb="2">
              회원 : 협회가 제공하는 서비스를 받기 위해 정회원이 된 자.
            </ListItem>
            <ListItem mb="2">
              종료 : 회원이 서비스를 이용 후 홈페이지를 종료하는 행위.
            </ListItem>
            <ListItem>
              본 약관에서 정의하지 않은 용어는 개별서비스에 대한 별도 약관 및
              이용규정에서 정의합니다.
            </ListItem>
          </OrderedList>
        </ListItem>
        <ListItem>
          <Heading as="h3" size="md" mt="5" mb="2">
            제2장 서비스 제공 및 이용
          </Heading>
          <UnorderedList>
            <Heading as="h4" size="sm" mt="3">
              제5조 (이용계약의 성립)
            </Heading>
            <UnorderedList listStyleType="decimal" pl="4">
              <ListItem mb="2">
                이용계약은 신청자가 온라인으로 당 홈페이지에서 제공하는 소정의
                가입신청 양식에서 요구하는 사항을 기록하여 가입을 완료하는
                것으로 성립됩니다.
              </ListItem>
              <ListItem mb="2">
                당 홈페이지는 다음 각 호에 해당하는 이용계약에 대하여는 가입을
                취소할 수 있습니다.
                <OrderedList listStyleType="decimal" pl="4">
                  <ListItem mb="2">
                    다른 사람의 명의를 사용하여 신청하였을 때
                  </ListItem>
                  <ListItem mb="2">
                    이용 계약 신청서의 내용을 허위로 기재하였거나 신청하였을 때
                  </ListItem>
                  <ListItem mb="2">
                    다른 사람의 당 홈페이지 서비스 이용을 방해하거나 그 정보를
                    도용하는 등의 행위를 하였을 때
                  </ListItem>
                  <ListItem mb="2">
                    당 홈페이지를 이용하여 법령과 본 약관이 금지하는 행위를 하는
                    경우
                  </ListItem>
                  <ListItem mb="2">
                    기타 당 홈페이지가 정한 이용신청요건이 미비 되었을 때
                  </ListItem>
                </OrderedList>
              </ListItem>
              <ListItem mb="2">
                당 홈페이지는 다음 각 항에 해당하는 경우 그 사유가 해소될 때까지
                이용계약 성립을 유보할 수 있습니다.
                <OrderedList listStyleType="decimal" pl="4">
                  <ListItem mb="2">
                    서비스 관련 제반 용량이 부족한 경우
                  </ListItem>
                  <ListItem mb="2">기술상 장애 사유가 있는 경우</ListItem>
                </OrderedList>
              </ListItem>
              <ListItem>
                당 홈페이지가 제공하는 서비스는 협회가 개발하거나 다른 기관과의
                협의 등을 통해 제공하는 일체의 서비스이며, 그 내용을 변경하여
                제공할 수 있습니다.
              </ListItem>
            </UnorderedList>
            <Heading as="h4" size="sm" mt="3">
              제6조 (이용자/회원 정보 사용에 대한 동의)
            </Heading>
            <Text mb="2">
              이용자/회원과 당 홈페이지에서 제시하는 개인정보 보호방침에 명기된
              권리와 의무를 보유합니다.
              <br />당 홈페이지의 이용자/회원 정보는 다음과 같이
              수집·사용·관리·보호됩니다.
            </Text>
            <UnorderedList listStyleType="decimal" pl="4">
              <ListItem mb="2">
                개인정보의 수집 : 당 홈페이지는 이용자/회원의 당 홈페이지 서비스
                가입 시 이용자/회원이 제공하는 정보를 통하여 이용자/회원에 관한
                정보를 수집합니다.
              </ListItem>
              <ListItem mb="2">
                개인정보의 사용 : 당 홈페이지는 서비스 제공과 관련해서 수집된
                이용자/회원의 정보를 본인의 승낙 없이 제3자에게 누설, 배포하지
                않습니다. 다만, 다음의 경우에는 예외로 합니다.
              </ListItem>
              <OrderedList listStyleType="decimal" pl="4">
                <ListItem mb="2">
                  배송 업무상 배송업체에게 배송에 필요한 최소한의 이용자
                  정보(성명, 주소, 전화번호)를 알려 주는 경우
                </ListItem>
                <ListItem mb="2">
                  통계 작성, 학술 연구 또는 시장 조사를 위하여 필요한 경우로서
                  특정 개인을 식별할 수 없는 형태로 제공되는 경우
                </ListItem>
                <ListItem mb="2">
                  재화 등의 거래에 따른 대금정산을 위하여 필요한 경우
                </ListItem>
                <ListItem mb="2">
                  이용자/회원이 당 홈페이지에 제공한 개인정보를 스스로 공개한
                  경우에는 그러하지 않습니다.
                </ListItem>
              </OrderedList>
              <ListItem mb="2">
                개인정보의 관리 : 이용자/회원은 수신되는 정보 중 불필요하다고
                생각되는 부분을 변경/ 조정할 수 있습니다.
              </ListItem>
              <ListItem mb="2">
                당 홈페이지를 이용하여 법령과 본 약관이 금지하는 행위를 하는
                경우
              </ListItem>
              <ListItem mb="2">
                개인정보의 보호 : 회원의 개인정보는 회원만이 열람할 수 있으며,
                이는 전적으로 회원의 고유인증에 의해 관리되고 있습니다. 따라서
                타인에게 본인의 인증번호를 알려주어서는 아니 되며, 작업 후
                반드시 종료 해주시고, 웹브라우저의 창을 닫아주시기 바랍니다.
                (이는 타인과 컴퓨터를 공유하는 인터넷 카페나 도서관 같은
                공공장소에서 컴퓨터를 사용하는 경우에 이용 자/회원의 정보의
                보호를 위하여 필요한 사항임)
              </ListItem>
            </UnorderedList>
            <Text mb="2">
              회원이 당 홈페이지에 본 약관에 따라 이용신청을 하는 것은 당
              홈페이지가 본 약관에 따라 신청서에 기재된 회원정보를 수집,
              이용하는 것에 동의하는 것으로 간주됩니다.
            </Text>
            <Heading as="h4" size="sm" mt="3">
              제7조 (회원의 정보 보안)
            </Heading>
            <UnorderedList listStyleType="decimal" pl="4">
              <ListItem mb="2">
                가입 신청자가 당 홈페이지 서비스 가입 절차를 완료하는 순간부터
                회원은 입력한 정보의 비밀을 유지할 책임이 있으며, 회원의 인증을
                통해 발생하는 모든 결과에 대한 책임은 회원 본인에게 있습니다.
              </ListItem>
              <ListItem>
                인증에 관한 모든 관리의 책임은 회원에게 있으며, 인증번호가
                부정하게 사용되었다는 사실을 발견한 경우에는 즉시 당 홈페이지에
                신고하여야 합니다. 신고를 하지 않음으로 인한 모든 책임은
                본인에게 있습니다.
              </ListItem>
              <ListItem>
                회원은 당 홈페이지 서비스의 사용 종료 시 마다 정확히 접속을
                종료하도록 해야 하며, 정확히 종료하지 아니함으로써 제3자가
                회원에 관한 정보를 이용하게 되는 등의 결과로 인해 발생하는 손해
                및 손실에 대하여 당 홈페이지는 책임을 부담하지 아니합니다.
              </ListItem>
            </UnorderedList>
            <Heading as="h4" size="sm" mt="3">
              제8조 (서비스 이용)
            </Heading>
            <UnorderedList listStyleType="decimal" pl="4">
              <ListItem mb="2">
                서비스 이용은 협회의 업무상 또는 기술상 특별한 지장이 없는 한
                연중무휴, 1일 24시간을 원칙으로 합니다.
              </ListItem>
              <ListItem>
                제1항의 이용시간은 정기점검 등의 필요로 인하여 당 홈페이지가
                정한 날 또는 시간은 예외로 합니다.
              </ListItem>
              <ListItem>
                협회에서 제공하는 서비스 중 일부는 회원에 가입하여 협회에서
                인정한 ID와 비밀번호를 통해서만 서비스를 받을 수 있습니다.{" "}
              </ListItem>
            </UnorderedList>
            <Heading as="h4" size="sm" mt="3">
              제9조 (계약 사항의 변경)
            </Heading>
            <Text>
              회원은 서비스이용 신청 시 기재한 사항이 변경되었을 경우, 즉시
              수정하여야 합니다.
            </Text>
            <Heading as="h4" size="sm" mt="3">
              제10조 (계약 해지 및 이용 제한)
            </Heading>
            <UnorderedList listStyleType="decimal" pl="4">
              <ListItem mb="2">
                회원이 서비스 이용 계약을 해지하고자 할 때는 회원 본인이 직접
                해지 신청을 해야 합니다.
              </ListItem>
              <ListItem>
                협회가 보관하고 있는 탈퇴 회원의 정보는 회원의 가입이력관리와
                지적재산권 관리, 개인정보보호를 위해서만 활용할 수 있습니다.{" "}
              </ListItem>
            </UnorderedList>
            <Heading as="h4" size="sm" mt="3">
              제11조 (서비스 이용제한)
            </Heading>
            <UnorderedList listStyleType="decimal" pl="4">
              <ListItem mb="2">
                이용자/회원이 제공하는 정보의 내용이 허위인 것으로 판명되거나,
                그러하다고 의심할 만한 합리적인 사유가 발생할 경우 당 홈페이지는
                이용자/회원의 본 서비스 사용을 일부 또는 전부 중지할 수 있으며,
                이로 인해 발생하는 불이익에 대해 책임을 부담하지 않습니다.
              </ListItem>
              <ListItem>
                이용자/회원이 당 홈페이지 서비스를 통하여 게시, 전송,
                입수하였거나 전자메일 기타 수단에 의하여 게시, 전송 또는 입수한
                모든 형태의 정보에 대하여는 이용자/회원이 모든 책임을 부담하며
                당 홈페이지는 어떠한 책임도 부담하지 않습니다.
              </ListItem>
              <ListItem>
                당 홈페이지는 당 홈페이지가 제공한 서비스가 아닌 이용자/회원
                또는 기타 유관기관이 제공하는 서비스의 내용상의 정확성, 완전성
                및 질에 대하여 보장하지 않습니다. 따라서, 당 홈페이지는
                이용자/회원이 위 내용을 이용함으로 인하여 입게 된 모든 종류의
                손실이나 손해에 대하여 책임을 부담하지 않습니다.
              </ListItem>
              <ListItem>
                이용자/회원은 본 서비스를 통하여 다음과 같은 행동을 하지 않는데
                동의합니다.
              </ListItem>
              <OrderedList listStyleType="decimal" pl="4">
                <ListItem mb="2">
                  타인의 성명과 인증으로 서비스를 이용하는 행위
                </ListItem>
                <ListItem mb="2">
                  음란, 모욕적, 위협적이거나 타인의 프라이버시를 침해할 수 있는
                  내용을 전송, 게시, 게재, 전자메일 또는 기타의 방법으로
                  전송하는 행위
                </ListItem>
                <ListItem mb="2">
                  서비스를 통하여 전송된 내용의 출처를 위장하는 행위{" "}
                </ListItem>
                <ListItem mb="2">
                  법률, 계약에 의하여 이용할 수 없는 내용을 게시, 게재, 전자메일
                  또는 기타의 방법으로 전송하는 행위
                </ListItem>
                <ListItem mb="2">
                  타인의 특허, 상표, 영업비밀, 저작권, 기타 지적재산권을
                  침해하는 내용을 게시, 게재, 전자메일 또는 기타의 방법으로
                  전송하는 행위
                </ListItem>
                <ListItem mb="2">
                  당 홈페이지의 승인을 받지 아니한 광고, 판촉물, 정크메일, 스팸,
                  행운의 편지, 피라미드 조직 기타 형태의 권유를 게시, 게재,
                  전자메일 또는 기타의 방법으로 전송하는 행위
                </ListItem>
                <ListItem mb="2">
                  다른 이용자/회원의 개인정보를 수집 또는 저장하는 행위
                </ListItem>
              </OrderedList>
              <ListItem>
                당 홈페이지는 이용자/회원이 본 약관을 위배했다고 판단되면
                서비스와 관련된 모든 정보를 이용자/회원의 동의 없이 삭제할 수
                있습니다.
              </ListItem>
            </UnorderedList>
            <Heading as="h4" size="sm" mt="3">
              제12조 (자격상실)
            </Heading>
            <Text>
              다음 각항의 사유에 해당하는 경우 협회는 사전 통보 없이 이용계약을
              해지하거나 기간을 정하여 서비스 이용을 중지할 수 있습니다.
            </Text>
            <UnorderedList listStyleType="decimal" pl="4">
              <ListItem mb="2">가입신청 시 허위 내용으로 등록한 경우</ListItem>
              <ListItem mb="2">
                타인의 아이디와 비밀번호, 주민등록번호 등을 도용한 경우
              </ListItem>
              <ListItem mb="2">
                협회, 다른 회원 또는 제3자의 지적재산권을 침해하는 경우
              </ListItem>
              <ListItem mb="2">
                사회의 안녕과 공공질서, 미풍양속을 해치는 행위를 하는 경우
              </ListItem>
              <ListItem mb="2">
                타인의 명예를 손상시키거나 불이익을 주는 행위를 한 경우
              </ListItem>
              <ListItem mb="2">
                같은 이용자가 다른 ID로 이중 등록을 한 경우
              </ListItem>
              <ListItem mb="2">범죄 행위에 관련되는 경우 </ListItem>
              <ListItem mb="2">
                정보통신망에 장애를 일으킬 수 있는 행위를 하는 경우
              </ListItem>
              <ListItem mb="2">
                협회의 허락 없이 협회의 서비스를 이용해 영리행위를 하는 경우
              </ListItem>
            </UnorderedList>
          </UnorderedList>
        </ListItem>
        <ListItem>
          <Heading as="h3" size="md" mt="5" mb="2">
            제3장 계약 당사자의 의무
          </Heading>
          <UnorderedList>
            <Heading as="h4" size="sm" mt="3">
              제13조 (협회의 의무)
            </Heading>
            <UnorderedList listStyleType="decimal" pl="4">
              <ListItem mb="2">
                협회는 서비스를 안정적, 지속적으로 제공할 의무가 있습니다.
              </ListItem>
              <ListItem mb="2">
                협회는 서비스 제공과 관련된 설비에 장애가 발생할 경우 신속히
                복구할 의무가 있습니다.
              </ListItem>
              <ListItem mb="2">
                협회는 회원이 제기한 의견이나 불만이 정당하다고 인정할 경우에는
                즉시 처리하여야 합니다.
              </ListItem>
              <ListItem mb="2">
                협회는 개인정보를 회원의 동의 없이 제3자에게 제공하지 않습니다.
                단, 특정 개인의 신상이 노출되지 않는 통계작성, 학술연구 등의
                목적일 경우, 범죄에 대한 수사상의 목적인 경우 기타 관계법령에서
                정한 절차에 따른 요청이 있는 경우에는 예외로 합니다.
              </ListItem>
              <ListItem mb="2">
                협회는 회원이 협회의 사이트를 편리하게 이용할 수 있도록 하기
                위해 회원의 정보를 제휴 사이트들과 공유할 수 있으며, 공유를 위해
                협회는 회원의 컴퓨터에 쿠키를 전송할 수 있습니다.
              </ListItem>
            </UnorderedList>
            <Heading as="h4" size="sm" mt="3">
              제14조 (이용자/회원의 의무)
            </Heading>
            <Text mb="2">
              이용자/회원은 서비스 사용에 있어서 협회와의 약속을 준수합니다.
            </Text>
            <Text mb="2">
              이용자/회원은 서비스의 이용권한, 기타 이용계약상의 지위를 타인에게
              양도, 증여할 수 없습니다. 협회의 사전 승인 없이 여타 개인 및
              조직에 서비스를 재판매하는 것은 허용되지 않습니다.
            </Text>
            <Text mb="2">
              이용자/회원은 협회로부터 허가받지 않은 광고물의 배포 및 게재를
              금지합니다.
            </Text>
            <Text mb="2">
              이용자/회원은 서비스와 연결된 모든 네트워크에 대한 접근 시 해당
              네트워크의 관련규칙을 성실히 준수해야 합니다.
            </Text>
            <Text mb="2">
              이용자/회원은 같은 서버를 이용하는 다른 고객에게 피해를 주어서는
              안 됩니다.
            </Text>
            <Text mb="2">
              이용자/회원은 ID와 비밀번호에 관한 모든 관리의 책임은 회원에게
              있습니다.
            </Text>
            <Text mb="2">
              이용자/회원은 협회에서 제공하는 서비스의 내용에 광고를 삽입할 수
              있음을 동의하여야 합니다.
            </Text>
          </UnorderedList>
        </ListItem>
        <ListItem>
          <Heading as="h3" size="md" mt="5" mb="2">
            제4장 게시물
          </Heading>
          <UnorderedList>
            <Heading as="h4" size="sm" mt="3">
              제15조 (이용자의 게시물)
            </Heading>
            <Text mb="2">
              게시물이라 함은 협회의 각종 게시판에 이용자가 게시한 게시물, 질문,
              답변, 자료를 모두 총칭합니다.
            </Text>
            <Text mb="2">
              협회는 아래에 해당되는 이용자의 게시물일 경우 사전통지 없이
              삭제합니다.
            </Text>
            <OrderedList listStyleType="decimal" pl="4">
              <ListItem mb="2">
                타인을 비방하거나 중상 모략하여 명예를 손상시키는 경우
              </ListItem>
              <ListItem mb="2">
                공공질서, 미풍양속에 저해되며 음란한 내용이나, 특정 종교를
                선전하거나 비방하는 내용, 기타 비형식적인 내용을 게재하는 경우{" "}
              </ListItem>
              <ListItem mb="2">
                협회의 저작권이나 제3자의 저작권등 기타 권리를 침해하는 내용인
                경우
              </ListItem>
              <ListItem mb="2">상업성이 있는 광고 게시물일 경우 </ListItem>
              <ListItem mb="2">
                협회에서 정하고 있는 게시기간을 초과한 경우
              </ListItem>
              <ListItem mb="2">
                기타 관계법령에 위반된다고 판단되는 경우
              </ListItem>
              <ListItem mb="2">
                정보통신 윤리위원회 등 관련 공공기관의 시정 요구가 있는 경우
              </ListItem>
            </OrderedList>
            <Text mb="2">
              협회는 2항의 이유로 삭제한 게시물의 보관의무를 갖지 않습니다.
            </Text>
          </UnorderedList>
          <UnorderedList>
            <Heading as="h4" size="sm" mt="3">
              제16조 (게시물의 이용 및 협회의 책임)
            </Heading>
            <UnorderedList listStyleType="decimal" pl="4">
              <ListItem mb="2">
                협회는 이용자가 등록한 게시물을 이용해 가공, 판매 등을 할 수
                있으며, 비즈니스 파트너 혹은 미디어에게 게시물의 내용을 제공할
                수 있습니다.
              </ListItem>
              <ListItem mb="2">
                협회는 모든 게시물을 검사 또는 검열할 의무를 갖지 않습니다.
              </ListItem>
              <ListItem mb="2">
                이용자의 게시물로 인하여 제3자의 협회에 대한 청구, 소송, 기타
                일체의 분쟁이 발생한 경우 이용자는 그 해결에 소요되는 비용을
                부담하고 협회를 위하여 분쟁을 처리하여야 하며, 협회가 제3자에게
                배상하거나 협회에 손해가 발생한 경우 이용자는 협회에 배상하여야
                합니다.
              </ListItem>
            </UnorderedList>
          </UnorderedList>
          <UnorderedList>
            <Heading as="h4" size="sm" mt="3">
              제17조 (면책)
            </Heading>
            <UnorderedList listStyleType="decimal" pl="4">
              <ListItem mb="2">
                협회는 통신사의 서버의 과실로 인한 피해는 책임지지 않습니다.
              </ListItem>
              <ListItem mb="2">
                협회는 회원이 유포한 불법 자료나 저작권과 관련된 자료로 입을 수
                있는 피해에 대하여 일체의 책임을 지지 않습니다.
              </ListItem>
              <ListItem mb="2">
                협회가 의무를 다했을 경우에 발생하는 피해에 대해서는 일체의
                책임을 지지 않습니다.
              </ListItem>
              <ListItem mb="2">
                협회는 천재지변 또는 이에 준하는 불가항력으로 인하여 서비스를
                제공할 수 없는 경우에는 서비스제공에 대한 책임이 없습니다.
              </ListItem>
              <ListItem mb="2">
                협회는 회원의 귀책사유로 인한 서비스 이용의 장애에 대하여 어떠한
                책임도 지지 않습니다.
              </ListItem>
              <ListItem mb="2">
                협회는 회원이 제휴 사이트의 서비스를 이용하여 얻은 자료로 인한
                손해, 회원과 제휴 사이트 간에 행해진 거래에 관하여는 어떠한
                책임도 지지 않습니다.
              </ListItem>
            </UnorderedList>
          </UnorderedList>
          <UnorderedList>
            <Heading as="h4" size="sm" mt="3">
              제 18조 (약관적용외 준칙)
            </Heading>
            <Text mb="2">
              이 약관에 명시되지 아니한 사항은 관계법령 및 상관행을 따르도록
              합니다.
            </Text>
          </UnorderedList>
          <UnorderedList>
            <Heading as="h4" size="sm" mt="3">
              제 19조 (관할법원)
            </Heading>
            <Text>
              본 약관은 대한민국 관련 법률의 적용을 받습니다. 각종 서비스
              이용으로 발생한 분쟁에 대해 소송이 제기될 경우 협회의 사업장
              소재지를 관할하는 법원을 관할법원으로 하는데 있어 동의합니다.
            </Text>
          </UnorderedList>
        </ListItem>
      </List>
    </Box>
  );
};

export default Terms01;
